import React from 'react';

export const LogoInstagram = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Instagram Icon</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-1112.000000, -609.000000)">
                <g>
                    <g transform="translate(120.000000, 593.000000)">
                        <g transform="translate(812.000000, 12.000000)">
                            <g transform="translate(176.000000, 0.000000)">
                                <g>
                                    <path
                                        d="M24,9.83003089 C24,10.6565849 23.3284449,11.3267284 22.4999726,11.3267284 C21.6716647,11.3267284 21,10.6565849 21,9.83003089 C21,9.0033675 21.6716647,8.33333333 22.4999726,8.33333333 C23.3284449,8.33333333 24,9.0033675 24,9.83003089"
                                        fill="#FFFFFF"
                                        fillRule="evenodd"
                                    />
                                    <path
                                        d="M16.0000213,11 C13.2386206,11 11,13.2386302 11,16.0000427 C11,18.7614979 13.2386206,21 16.0000213,21 C18.7614221,21 21,18.7614979 21,16.0000427 C21,13.2386302 18.7614221,11 16.0000213,11"
                                        stroke="#FFFFFF"
                                        strokeWidth="1.75"
                                    />
                                    <rect
                                        stroke="#FFFFFF"
                                        strokeWidth="1.75"
                                        x="5.15999985"
                                        y="5.15999985"
                                        width="21.6666667"
                                        height="21.6666667"
                                        rx="4.5"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
